import { Country } from "@domain/currentProfile/countryCode";
import { AfricanCountryCode } from "./africanCountryCode";
import { ApplicationDraft } from "./applicationDraft";

export const allApplicationMemberStatus = ["NOT_COMPLETED", "COMPLETED", "PENDING_VALIDATION"] as const;
export type ApplicationMemberStatus = (typeof allApplicationMemberStatus)[number];

export const ApplicationLevels = ["Bachelor", "Master", "MBA"] as const;
export type ApplicationLevel = (typeof ApplicationLevels)[number];

export type ApplicationType = "OMAT" | "OMAT_V2";

export interface Application extends Omit<ApplicationDraft, "countryResidence"> {
	id: string;
	hasAlreadyVoted: boolean;
	voteCount: number;
	status: ApplicationMemberStatus;
	countryResidence: Country;
}

export interface ApplicationVote {
	key: string;
	slug: string;
	date: string;
}

export type ApplicationFilterOptions = {
	status?: ApplicationMemberStatus;
	countryResidence?: AfricanCountryCode;
	levelName?: ApplicationLevel;
};

export type ApplicationStatusCounts = { [key in ApplicationMemberStatus]?: number };
